import React from 'react';
import PropTypes from 'prop-types';

import './AnnouncementModal.scss';

/**
 * AnnouncementModal is used to display fullscreen announcements to the user.
 * It is a presentational component, and as such should be a sub-component of more specific modal components
 * such as <NotificationsAnnouncementModal>
 */
AnnouncementModal.propTypes = {
  
  /** Text to be displayed in modal header */
  headingText: PropTypes.string,
  /** Text to be displayed in modal sub-header */
  subHeadingText: PropTypes.string,
  /** Text to be displayed in modal body */
  bodyText: PropTypes.string,
  /** Function called by the parent when the modal is closed */
  onClose: PropTypes.func,
};

export default function AnnouncementModal(props) {

  return (
    <article className='announcement-modal'>
      <span className='announcement-modal__x' onClick={props.onClose}>&times;</span>
      <h1 className='announcement-modal__heading'>{props.headingText}</h1>
      <h2 className='announcement-modal__subheading'>{props.subHeadingText}</h2>
      <p className='announcement-modal__body'>{props.bodyText}</p>
      {props.children}
    </article>  
  );
}



// WEBPACK FOOTER //
// ./src/components/modals/AnnouncementModal/index.js